import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShopTranslationsService {

  constructor() { }

  initialize(): Observable<boolean> {
    return of();
  }

}
